import React from 'react';
import { format } from 'date-fns';
import { Button } from '@/components/ui/button';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow
} from '@/components/ui/table';
import { Loader2, Trash2, Upload, FileText, Download, Eye } from 'lucide-react';

// Documents Tab for the Export edit sheet. Simpler than the Load variant —
// no AI auto-detect / bulk type changes; just upload-list-preview-delete.
export const DocumentsTab = ({
  documents, uploading, onUpload, onDelete, onDownload, onPreview, fileInputRef,
}) => (
  <div className="space-y-4">
    <div className="flex items-center gap-2">
      <input
        type="file"
        ref={fileInputRef}
        onChange={onUpload}
        className="hidden"
        accept=".pdf,.png,.jpg,.jpeg,.doc,.docx,.xls,.xlsx"
        multiple
      />
      <Button
        size="sm"
        onClick={() => fileInputRef.current?.click()}
        disabled={uploading}
        className="bg-blue-600 hover:bg-blue-500"
      >
        {uploading ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <Upload className="h-4 w-4 mr-1" />}
        Upload Documents
      </Button>
      <span className="text-xs text-slate-500">Select multiple files</span>
    </div>
    <div className="border border-slate-800 rounded-lg overflow-hidden">
      <Table>
        <TableHeader className="bg-slate-950">
          <TableRow>
            <TableHead className="text-slate-400">Name</TableHead>
            <TableHead className="text-slate-400">Type</TableHead>
            <TableHead className="text-slate-400">Size</TableHead>
            <TableHead className="text-slate-400">Uploaded</TableHead>
            <TableHead className="text-slate-400 text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {documents.map(doc => (
            <TableRow key={doc.id} className="border-slate-800">
              <TableCell className="text-white flex items-center gap-2">
                <FileText className="h-4 w-4 text-blue-400" />
                {doc.name}
              </TableCell>
              <TableCell className="text-slate-300">{doc.type || 'Document'}</TableCell>
              <TableCell className="text-slate-300">{doc.size ? `${(doc.size / 1024).toFixed(1)} KB` : '-'}</TableCell>
              <TableCell className="text-slate-400 text-sm">{doc.uploaded_at ? format(new Date(doc.uploaded_at), 'MM/dd/yyyy') : '-'}</TableCell>
              <TableCell className="text-right">
                <div className="flex items-center justify-end gap-1">
                  <Button variant="ghost" size="sm" onClick={() => onPreview(doc)} className="h-7 w-7 p-0">
                    <Eye className="h-4 w-4" />
                  </Button>
                  <Button variant="ghost" size="sm" onClick={() => onDownload(doc)} className="h-7 w-7 p-0">
                    <Download className="h-4 w-4" />
                  </Button>
                  <Button variant="ghost" size="sm" onClick={() => onDelete(doc.id)} className="h-7 w-7 p-0 text-red-400">
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          ))}
          {documents.length === 0 && (
            <TableRow>
              <TableCell colSpan={5} className="text-center text-slate-500 py-8">No documents uploaded yet</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  </div>
);
